import { useState, } from 'react';

import { Button, Form } from 'react-bootstrap';
import CreateIcon from '@material-ui/icons/Create';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import DeleteIcon from '@material-ui/icons/Delete';

import api from '../../services/api'

import { showToast } from '../../ui-lib/toast'
import 'react-toastify/dist/ReactToastify.css'

import ConfirmDialog from '../ConfirmDialog';

import useModal from '../../hooks/useModal';


function refreshPage(info) {
  window.location.reload(info)
}


const CorpoCadScrip = ({ data, onDelete, }) => {
  const deleteModal = useModal();
  const [name, setName] = useState(data.name)
  const [group, setGroup] = useState(data.grupo)


  function onDeleteConfirmed() {
    onDelete(data._id);
    deleteModal.onClose();
  }

  const handleButtonClick = async () => {
    await api.post('/gen/token', {
      id: data._id,
    })
    return refreshPage()
  }

  const handleButtonClickChanges = async () => {
    await api.post('/scripts/changes', {
      name: name,
      id: data._id,
    })
    return refreshPage()
  }

  const handleButtonClickGroup = async () => {
    await api
      .post('/update/groups', {
        grupo: group,
        id: data._id,
      })
      .then((response) => {
        showToast({ type: 'success', message: `${response.data}` })
      })
      .catch((response) => {
        showToast({ type: 'error', message: `${response.data}` })
      })
  }


  return (
    <tr>
      <td>
        <Form.Group controlId="exampleForm.ControlSelect1" size="sm">
          <Form.Control
            as="select"
            size="sm"
            defaultValue="Selecione um horario"
            value={group}
            onChange={(event) => {
              setGroup(event.target.value)
            }}
          >
            <option>Selecione um horario</option>
            <option>8:30</option>
            <option>23:59</option>
          </Form.Control>
        </Form.Group>
      </td>
      <td>
        <Form.Control
          style={{ width: '17rem' }}
          as="textarea"
          row={3}
          value={name}
          onChange={(event) => {
            setName(event.target.value)
          }}
        />
      </td>
      <td>{new Date(data.createdAt).toLocaleDateString()}</td>
      <td>
        {data.token}
      </td>

      <td>
        <div
          style={{
            display: 'flex',
            direction: 'row',
            justifyContent: 'space-around'
          }}
        >
          <Button
            variant="dark"
            size="sm"
            onClick={handleButtonClick}
            style={{
              marginRight: '0.25rem',
            }}
          >
            <VpnKeyIcon fontSize="small" /> Gerar token
          </Button>

          <Button
            variant="warning"
            size="sm"
            onClick={handleButtonClickChanges}
            style={{
              marginRight: '0.25rem',
            }}
          >
            <CreateIcon fontSize="small" />
            Alterar nome
          </Button>

          <Button
            variant="light"
            size="sm"
            onClick={handleButtonClickGroup}
            style={{
              marginRight: '0.25rem',
            }}
          >
            Salvar grupo
          </Button>

          <Button
            variant="danger"
            size="sm"
            onClick={() => deleteModal.onOpen(data._id)}
            style={{
              marginRight: '0.25rem',
            }}
            disabled={undefined == onDelete}
          >
            <DeleteIcon />
            Excluir
          </Button>
        </div>
      </td>

      <ConfirmDialog
        open={deleteModal.value}
        onClose={() => deleteModal.onClose()}
        onConfirm={onDeleteConfirmed}
        text="Tem certeza que deseja excluir o script?"
        secondaryText="O script será excluído permanentemente"
        confirmationButtonLabel="Excluir"
        buttonBackgroundColor="red"
      />
    </tr>
  )
}

export default CorpoCadScrip
